export default __webpack_public_path__ + "static/media/extension_giftcard_gold_w4.b561a43f.svg";